import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "controller-info" }
const _hoisted_2 = { key: 0 }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useMqttStore } from '@/store/mqttStore'
import { storeToRefs } from 'pinia'
import BikeFunctions from '@/components/controls/BikeFunctions.vue'
import { MqttTopic } from '@/mqttDefinitions/topics'


export default /*@__PURE__*/_defineComponent({
  __name: 'ControllerInfo',
  setup(__props) {

const mqttStore = useMqttStore()
const { t } = useI18n()

const { doSubscribe, client } = mqttStore
const versionTopic = MqttTopic.CONTROLLER_VERSION

const { getRawValueOnTopic } = storeToRefs(mqttStore)

doSubscribe(versionTopic, client)

const versionData = computed(() => {
  const rawValue = getRawValueOnTopic.value(versionTopic)

  if (
    rawValue &&
    typeof rawValue === 'object' &&
    'version' in rawValue &&
    typeof rawValue.version === 'string'
  ) {
    return rawValue as { version: string }
  }

  return null
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (versionData.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('app.fitbike.version', { version: versionData.value.version })), 1))
      : _createCommentVNode("", true),
    _createVNode(BikeFunctions)
  ]))
}
}

})